'use client';

import { useFormFields } from '@payloadcms/ui';
import React from 'react';

const VideoPreview = () => {
  const field = useFormFields(([fields]) => {
    const data = fields;
    return {
      url: data?.url?.value as string | undefined,
      mimeType: data?.mimeType?.value as string | undefined,
      filename: data?.filename?.value as string | undefined,
    };
  });

  return (
    <div
      style={{
        marginTop: '1rem',
        marginBottom: '1rem',
      }}
    >
      <div style={{ marginBottom: '0.5rem' }}>
        <strong>Video Preview:</strong>
      </div>
      <div
        style={{
          width: '600px',
          height: '400px',
          borderRadius: '4px',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <video
          controls
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        >
          <source src={field.url} type={field.mimeType} />
        </video>
      </div>
    </div>
  );
};

export default VideoPreview;
